import React, { useState, useEffect, useContext } from "react";
import { Card, ButtonGroup, Popover, Button, ActionList, Text } from "@shopify/polaris";
import { ViewMinor, CodeMajor, LanguageMinor } from "@shopify/polaris-icons";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../components/global/appContext";
import moment from "moment";

export default function ThemeCard(props) {
  const { t } = useTranslation();
  const appContext = useContext(AppContext);
  const { id, name, image_url, updated_at } = props.theme;

  const [popoverActive, setPopverActive] = useState(false);

  // const popoverButton = (
  //   <Button
  //     onClick={() => setPopverActive(!popoverActive)}
  //     disclosure
  //     loading={props.loading}
  //   >
  //     Actions
  //   </Button>
  // );

  // let themeActions = [
  //   {
  //     content: "View",
  //     url: `https://${appContext.shopDomain}${appContext.proxyPath}`,
  //     icon: ViewMajor,
  //   },
  // ];

  // if (props.hasCustomThemeAccess) {
  //   themeActions.push({
  //     content: "Edit code",
  //     url: `/themes/live/templates`,
  //     icon: CodeMajor,
  //     // helpText: "Edit how your theme looks",
  //   });
  // }

  // themeActions.push({
  //   content: "Edit language",
  //   url: `/themes/live/language`,
  //   icon: LanguageMinor,
  //   // helpText: "Manage your blog articles",
  // });

  return (
    <Card>
      <Card.Header
        title={
          <>
            <Text variant="headingMd" as="h2">{name}</Text>
            <Text  variant="bodyMd" as="span" color="subdued">{t("themes.card.lastUpdated")} {moment(updated_at).from(moment())}</Text>
          </>
        }
      >
        <ButtonGroup>
          {/* <Popover
            active={popoverActive}
            activator={popoverButton}
            onClose={() => setPopverActive(false)}
          >
            <ActionList items={themeActions} />
          </Popover> */}
          <Button
            url={appContext.appProxyLandingURL}
            external
            // icon={ViewMinor}
          >
            {t("themes.card.view")}
          </Button>
          <Button primary url={`/themes/live`} loading={props.loading}>
            {t("themes.card.customize")}
          </Button>
        </ButtonGroup>
      </Card.Header>
      <Card.Section flush>
        <div className="theme-preview-image-container primary">
          <img src={image_url} />
        </div>
      </Card.Section>
    </Card>
  );
}
// "https://miro.medium.com/max/2000/1*UzmjsSZkY4m7S_nBXMC9AQ.png"
